import { Center } from '../../lib/types/models/center/center'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export type AssignMobileToCenterRequest = {
  centerId: number
  mobileNumberForFrenchLeaderId: number
}

export const assignMobileNumberToCenter = (input: AssignMobileToCenterRequest) => {
  const { centerId, mobileNumberForFrenchLeaderId } = input
  return restApiClient
    .url(
      constructApiUrl(API.centers.assignMobileNumberToCenter.url, {
        id: centerId,
        mobileNumberForFrenchLeaderId
      })
    )
    .post<Center>()
}
